module.exports = __webpack_public_path__ + "img/Bilde1.bd6e0f01.jpg";